export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/constant.js
// module id = 652
// module chunks = 0